import { render, staticRenderFns } from "./CustomWebhook.vue?vue&type=template&id=0b8804fc"
import script from "./CustomWebhook.vue?vue&type=script&lang=js"
export * from "./CustomWebhook.vue?vue&type=script&lang=js"
import style0 from "./CustomWebhook.vue?vue&type=style&index=0&id=0b8804fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports